export default __webpack_public_path__ + "static/media/black4.08472638.gif";